// Module
var code = "<a\n    class=\"k-button dms-sidemenu-button dms-notification-button dms-tooltip\"\n    data-bind=\"attr: { data-dms-tooltip: getUserDataTextBlockToolTipNotifications }\"\n>\n    <i class=\"far fa-bell\"></i>\n    <span class=\"dms-notification-badge\" data-bind=\"text:count, visible: count\"></span>\n</a>\n";
// Exports
export default code;